export default {"src":"/_next/static/media/x.e3504fcd.svg","height":48,"width":48};